import { Component,  Input } from '@angular/core';
import { PhotoData } from '../../../../globals/store/user.data';
import { IconComponent } from '../icon/icon.component';
import { PhotoComponent } from '../photo';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'photo-toggle-card',
    template: `
<div class="item smooth" [ngClass]="{selected: selected, disabled: disabled }">
  <photo [data]="photoData" ></photo>
  <div class="name" [title]="showTitle && name ? name : null" >{{ name }}</div>
  <div style="flex:1"></div>
  <icon class="check" [ngClass]="{selected: true, invisible: !selected}" icon="tick_24px"></icon>
  <div class="bg smooth"></div>
</div>
`,
    styleUrls: ['./filters-bar.scss'],
    imports: [IconComponent, PhotoComponent, CommonModule],
    standalone: true
})
export class PhotoToggleCardComponent {
  @Input() bottomHeight = null
  @Input() photoData: PhotoData
  @Input() name: string
  @Input() selected = false
  @Input() disabled = false
  @Input() showTitle = false
}

